import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteVideo } from "./deleteVideo.request";
import { DeleteVideoResponse } from "./deleteVideo.types";

const useDeleteVideo = (
  options?: MutationOptions<DeleteVideoResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteVideo,
    onError: toastServerError,
    ...options
  });
};

export default useDeleteVideo;
